document.addEventListener('DOMContentLoaded', function() {
  const slider = document.getElementById('usp-slider');
  if (!slider) return;

  // Duplicate content for infinite effect
  const slides = slider.innerHTML;
  slider.innerHTML += slides;
});
